module.exports = __webpack_public_path__ + "static/synergy-35fb052624f8331757875e5aef6744fa.png";